import { apiGet } from "../../utils"

export function getAvailableDateRangesAPI(store) {
    const query = store ? `?store=${store}` : ''
    return apiGet(`/api/getAvailableDateRanges${query}`)
}

export function getAnalyticsDataLabelAPI(file, filter_user_id) {
    let query = `?file=${encodeURIComponent(file)}`
    if (filter_user_id) query += `&filter_user_id=${filter_user_id}`
    return apiGet(`/api/getAnalyticsDataLabel${query}`)
}

export function getLabelUsersForFilterAPI() {
    return apiGet(`/api/getLabelUsersForFilter`)
}
